import { Typography } from "@mui/material";
import SinglePredictionInterval from "./SinglePredictionInterval";

const PredictionInterval = ({ intervals, timezone, conditionType, predictionType }) => {
    if (!intervals?.length) return null;

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "8px"
            }}
        >
            {intervals.map((interval, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "8px"
                    }}
                >
                    <SinglePredictionInterval
                        interval={interval}
                        timezone={timezone}
                        predictionType={predictionType}
                        conditionType={conditionType}
                    />

                    {index < intervals.length - 1 && (
                        <Typography
                            variant="caption"
                            color="primary.main"
                            sx={{
                                display: "block",
                                mb: 1,
                                fontSize: "0.875rem",
                                fontWeight: "medium",
                            }}>||</Typography>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PredictionInterval;
